import {
  Grid,
  Card,
  CardHeader,
  CardContent,
  TextField,
  Button,
} from "@material-ui/core";
import { useSelector } from "react-redux";
import UserAvatar from "../../assets/img/user-avatar.png";
import {
  ERROR_COLOR,
  GREEN_PRIMRY,
  HOST,
  ORANGE_COLOR,
} from "../../utils/const";
import { useHistory } from "react-router";
import useCustomState from "../../hooks/State";
import { useEffect } from "react";
import Call from "../../service/API";
import { useDispatch } from "react-redux";
import { UpdateProfile } from "../../store/actions";
import SuccessModal from "../generalModals/SuccessModal";

const EditAdminInfo = (props) => {
  const profile = useSelector((state) => state.adminProfile);

  const fileResult = profile.other_information.file_result;
  const avatar =
    fileResult == undefined ? UserAvatar : HOST + fileResult.fileurl;

  const successModalOpen = useCustomState(false);
  const successTitle = useCustomState("");
  const successMessage = useCustomState("ویرایش اطلاعات با موفقیت انجام شد.");

  const username = useCustomState("");
  const userLastName = useCustomState("");

  const usernameError = useCustomState({ error: false, text: "" });
  const userLastNameError = useCustomState({ error: false, text: "" });

  const usernameChanged = (e) => {
    usernameError.handleChange({ error: false, text: "" });
    username.handleChange(e.target.value);
  };

  const userLastNameChanged = (e) => {
    userLastNameError.handleChange({ error: false, text: "" });
    userLastName.handleChange(e.target.value);
  };

  useEffect(() => {
    username.handleChange(profile.admin_name);
    userLastName.handleChange(profile.admin_lastname);
  }, []);

  const dispatch = useDispatch();

  const openSuccessModal = () => {
    successModalOpen.handleChange(true);
  };

  const editUser = (e) => {
    let hasError = false;
    const name = username.value;
    const lastName = userLastName.value;

    if (name.length == 0) {
      usernameError.handleChange({
        error: true,
        text: "واردکردن نام الزامی است.",
      });
      hasError = true;
    }
    if (lastName.length == 0) {
      userLastNameError.handleChange({
        error: true,
        text: "واردکردن نام خانوادگی الزامی است.",
      });
      hasError = true;
    }
    if (hasError) {
      return;
    }

    const info = {
      admin_name: name,
      admin_lastname: lastName,
      other_information: {
        description: "",
      },
    };

    const data = new FormData();
    data.append("data", JSON.stringify(info));

    Call("POST", "admins/admin/setProfile", data)
      .then((response) => {
        // console.log(response);
        if (response.data.code == 200) {
          dispatch(UpdateProfile({ updateProfile: true }));
          openSuccessModal();
        }
      })
      .catch((error) => {
        if (error.response) {
          const data = error.response.data;
          // console.log(data);
        }
      });
  };

  const history = useHistory();
  const goToDashboard = (e) => {
    history.push("/admin");
  };
  return (
    <>
      <SuccessModal
        open={successModalOpen}
        title={successTitle.value}
        message={successMessage.value}
        style={{ successColor: GREEN_PRIMRY }}
      />
      <Grid item sx={12} sm={12} md={12} lg={12} style={{ marginTop: "60px" }}>
        <Card
          align="center"
          style={{
            width: "100%",
            marginTop: "16px",
            marginBottom: "16px",
            overflow: "visible",
          }}
        >
          <img
            style={{
              borderRadius: "50%",
              border: "4px solid white",
              marginTop: "-40px",
            }}
            src={avatar}
            width="140px"
            height="140px"
            alt="User-Avatar"
          />
          <CardContent
            style={{
              padding: "16px",
              position: "relative",
              overflow: "visible",
            }}
          >
            <Grid
              container
              style={{ paddingTop: "24px", paddingBottom: "8px" }}
            >
              <Grid
                item
                xs={12}
                sm={12}
                md={6}
                lg={6}
                style={{
                  paddingRight: "5%",
                  paddingLeft: "5%",
                  marginTop: "16px",
                  marginBottom: "16px",
                }}
              >
                <TextField
                  error={usernameError.value.error}
                  helperText={usernameError.value.text}
                  onChange={usernameChanged}
                  value={username.value}
                  fullWidth
                  variant="standard"
                  label="نام"
                  InputLabelProps={{
                    style: {
                      fontFamily: "Vazir",
                    },
                  }}
                  size="small"
                ></TextField>
              </Grid>
              <Grid
                item
                xs={12}
                sm={12}
                md={6}
                lg={6}
                style={{
                  paddingRight: "5%",
                  paddingLeft: "5%",
                  marginTop: "16px",
                  marginBottom: "16px",
                }}
              >
                <TextField
                  error={userLastNameError.value.error}
                  helperText={userLastNameError.value.text}
                  onChange={userLastNameChanged}
                  value={userLastName.value}
                  fullWidth
                  variant="standard"
                  label="نام خانوادگی"
                  InputLabelProps={{
                    style: {
                      fontFamily: "Vazir",
                    },
                  }}
                  size="small"
                ></TextField>
              </Grid>
              <Grid
                item
                xs={12}
                sm={12}
                md={12}
                lg={12}
                style={{
                  paddingRight: "5%",
                  paddingLeft: "5%",
                  marginTop: "48px",
                }}
                align="right"
              >
                <Button
                  onClick={editUser}
                  style={{ color: "#fff", backgroundColor: ORANGE_COLOR }}
                  variant="contained"
                >
                  ویرایش
                </Button>
                <Button
                  onClick={goToDashboard}
                  style={{
                    color: "#fff",
                    backgroundColor: ERROR_COLOR,
                    marginRight: "8px",
                  }}
                  variant="contained"
                >
                  بازگشت
                </Button>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Grid>
    </>
  );
};

export default EditAdminInfo;
